export const environment = {
  production: false,
  backendUrl: "/api",
  backendAuctionsFormRequestUrl: "/api/applications/auctions/inquiry/contact-form",
  backendAuctionsSpecialOfferFormRequestUrl: "/api/applications/auctions/inquiry/special-offer-form",
  backendParkingFormRequestUrl: "/api/applications/autopark/inquiry/contact-form",
  recaptcha: {
    siteKey: "6LfG2bYrAAAAADN-jnir1afsNEXluJwI6V7JP0j4"
  },
  privacyPolicyUrl: "https://www.processway.pl/polityka-prywatnosci/",
  specialOfferUrl: "https://www.licytacje.processway.pl/list/wszystkie?stan=nowy,uzywany&finansowanie=special-offer-offering&sortowanie=popularnosc,rosnaco",
  contactUrl: "https://www.licytacje.processway.pl/#contact",
  analytics: {
    google: {
      enabled: false,
      debug: false,
      gtmContainerId: "GTM-NBG5RJKB"
    },
    meta: {
      enabled: false,
      pixelId: "3711427579137399"
    },
    microsoft: {
      enabled: true,
      clarityProjectId: 'vnxb84elkt'
    }
  }
}
